module.exports = __webpack_public_path__ + "static/media/0103carousel-working.ced69c55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0103carousel-working.jpg
// module id = 389
// module chunks = 0